<span
  class="ex-pill"
  [class.ex-pill--neutral]="variant === 'neutral'"
  [class.ex-pill--info]="variant === 'info'"
  [class.ex-pill--success]="variant === 'success'"
  [class.ex-pill--warning]="variant === 'warning'"
>
  @if (showSpinner) {
    <span class="ex-pill__spinner"></span>
  } @else if (phosphorIcon) {
    <i class="ex-pill__icon ph" [ngClass]="'ph-' + phosphorIcon"></i>
  }
  <span class="ex-pill__label">
    <ng-content />
  </span>
</span>
